export default __webpack_public_path__ + "static/media/help-center.3496c08f.png";